/**
 * useRouteActivityLogger — fires audit events on route transitions.
 *
 * Placed at the top of the Router tree. On every location change,
 * determines the event type and fires logURLEvent.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { logURLEvent, parseSearchParams } from "@/lib/logURLEvent";

export default function useRouteActivityLogger() {
    const location = useLocation();
    const { user } = useAuth();
    const prev = useRef(null);

    useEffect(() => {
        // Only log for authenticated users
        if (!user?.id) return;

        const path = location.pathname;
        const params = parseSearchParams(location.search);
        const prevPath = prev.current;
        prev.current = path;

        // Skip initial mount where prevPath is null (or same exact path)
        if (prevPath === path && !params.verifyKey && !params.action) return;

        // Classify event type
        let eventType = "NAVIGATION_DEEP_LINK";

        if (params.verifyKey === "true") {
            eventType = "DUAL_KEY_TRIGGER";
        } else if (path.includes("/copilot/")) {
            eventType = "COPILOT_TIER_ACCESS";
        } else if (params.layout) {
            eventType = "LAYOUT_SHARE_HYDRATE";
        }

        logURLEvent(eventType, path, params);
    }, [location.pathname, location.search, user?.id]);
}
